'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { InformationCircleIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { BadgeHttp } from '../../../components/styled/badge-http';
import { IconButton } from '../../../components/icon-button';
import { Tooltip } from '../../../components/tooltip';
import { MetaDefault, MonoDefault } from '../../../components/typography';

type UnverifiedAssetLockedEndpointFieldProps = {
  method: string;
  endpoint: string;
  label: string;
  helpText?: string;
};

export function UnverifiedAssetLockedEndpointField({
  method,
  endpoint,
  label,
  helpText,
}: UnverifiedAssetLockedEndpointFieldProps) {
  const t = useTranslations('designSystem.applicationAssets');

  return (
    <VStack gap="1.5" alignItems="stretch" w="full">
      <HStack gap="1.5" alignItems="center">
        <MetaDefault color="fg.muted">{label}</MetaDefault>
        {helpText ? (
          <Tooltip title={helpText}>
            <IconButton
              variant="ghost"
              size="xs"
              aria-label={t('rerunContextFieldHelp')}
            >
              <InformationCircleIcon size={14} />
            </IconButton>
          </Tooltip>
        ) : null}
      </HStack>
      <HStack
        gap="2"
        alignItems="center"
        w="full"
        minH="8"
        px="3"
        py="1.5"
        borderWidth="1px"
        borderColor="border.subtle"
        borderRadius="md"
        bg="bg.muted"
        aria-readonly="true"
      >
        <BadgeHttp method={method} size="sm">
          {method}
        </BadgeHttp>
        <MonoDefault
          color="fg.default"
          minW={0}
          flex="1"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          title={endpoint}
        >
          {endpoint}
        </MonoDefault>
      </HStack>
    </VStack>
  );
}
